const ValidateEmail = (email: string) => {
  const validDomains = [
    'trajector.com',
    'trajectorservices.com',
    'trajectormedical.com',
    'trajectorengineering.com',
  ];

  const [local, domain] = email.split('@');
  const specialCharsRegex = /[ &*#?/\\:@!]/;

  const validations = [
    {
      condition: email === '',
      message: 'Email cannot be empty',
    },
    {
      condition: !local || !domain,
      message: 'Please enter a valid email address',
    },
    {
      condition: specialCharsRegex.test(local),
      message: 'Email contains invalid characters',
    },
    {
      condition: !validDomains.includes(domain),
      message: 'Email domain is not allowed',
    },
    {
      condition: email.length > 254,
      message: 'Email length cannot exceed 254 characters',
    },
  ];

  for (const { condition, message } of validations) {
    if (condition) {
      return {
        message,
        messageType: 'error',
      };
    }
  }

  return;
};

export default ValidateEmail;
